import React, { useContext }  from 'react'
import ProductTypeList from './ProductTypeList'
import Loading from './loading'
import { AppContext } from '../App'

export default function ProductTypeSelection() {
   const { loading } = useContext(AppContext)
   return (
      <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
         {
            // Check to see if loading is active. If so, show loading component. Else show the product type list.
            loading ? (
               <Loading type="all products and systems" />
            ) : (
               <ProductTypeList />
            )
         }
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/ProductTypeSelection.js